import { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import { Col, Collapse, Dropdown, DropdownMenu, DropdownToggle, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, Row } from "reactstrap";
import { HeaderData } from "../../../Data/Layout/Header";
import { useAppDispatch, useAppSelector } from "../../../ReduxToolkit/Hooks";
import { setDropdownOpen, setNavbar } from "../../../ReduxToolkit/Reducers/Layout";
import { Route } from "../../../Routers/RouteList";
import { HeaderType } from "../../../Types/CommonComponentsType";
import { dynamicImage, Image } from "../../../Utils";

const Header = ({ landing }: HeaderType) => {
  const dispatch = useAppDispatch();
  const { DropdownOpen, isNavbar } = useAppSelector((state) => state.layout);

  useEffect(() => {
    const header = document.querySelector(".landing-header");
    if (header) {
      const handleScroll = () => {
        if (window.scrollY > 60) header.classList.add("fixed");
        else header.classList.remove("fixed");
      };
      window.addEventListener("scroll", handleScroll);
      handleScroll();
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return (
    <header id="home">
      <div className="custom-container">
        <Row>
          <Col xs="12">
            <div className="landing-header">
              <div className="main-menu">
                <Navbar expand="sm" className="navbar-light">
                  <NavbarBrand href={Route.Messenger}>
                    <div className="logo-block">
                      {landing ? (
                        <Image className="img-fluid" src={dynamicImage("logo/logo-white-2.png")} alt="logo" />
                      ) : (
                        <Fragment>
                          <Image className="img-fluid for-light" src={dynamicImage("logo/landing-logo.png")} alt="logo" />
                          <Image className="img-fluid for-dark" src={dynamicImage("logo/logo-white-1.png")} alt="logo" />
                        </Fragment>
                      )}
                    </div>
                  </NavbarBrand>
                  <NavbarToggler className="d-xl-none" onClick={() => dispatch(setNavbar())} />
                  <Collapse navbar className="d-xl-block" id="navbarNav" isOpen={isNavbar}>
                    <Nav navbar>
                      {HeaderData.map((item, index) => (
                        <NavItem active={item.active} key={index}>
                          {item.title && <Link to={item.url} className="nav-link">{item.title}</Link>}
                          {item.dropdown && (
                            <Dropdown isOpen={DropdownOpen[index]} toggle={() => dispatch(setDropdownOpen(index))}>
                              <DropdownToggle nav caret>
                                {item.dropdownTitle}
                              </DropdownToggle>
                              <DropdownMenu>
                                {item.dropdown.map((subItem, subIndex) => (
                                  <Link key={subIndex} to={subItem.url} className="nav-link" onClick={() => dispatch(setDropdownOpen(index))}>
                                    <span onClick={() => dispatch(setNavbar())}>{subItem.title}</span>
                                  </Link>
                                ))}
                              </DropdownMenu>
                            </Dropdown>
                          )}
                        </NavItem>
                      ))}
                    </Nav>
                  </Collapse>
                </Navbar>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </header>
  );
};

export default Header;
